import { render, staticRenderFns } from "./activityInstitutesBasicDetails.html?vue&type=template&id=97bac224&scoped=true&external"
import script from "./activityInstitutesBasicDetails.vue?vue&type=script&lang=js"
export * from "./activityInstitutesBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./activityInstitutesBasicDetails.css?vue&type=style&index=0&id=97bac224&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bac224",
  null
  
)

export default component.exports